import {
  includeRule,
  excludeRule,
  hideOptionSet
}
from './rules_functions.js';

  
  
export function rules_rsetc(newState, state) {
  //rules with 4 conditions:
  var newrule = includeRule(newState, state, 'rsetc')
  var show  = hideOptionSet(newState, state, [ ['rset', ['0']]])
  newrule = excludeRule(newState, state, [
    ['ce', ['LD']],
    ['rsetc', ['BDI','BDID']]], newrule)

  newrule['show']  = show
    return newrule
}


